import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../models/alert-info';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { ProposalsService } from '../../../../services/api/proposals.service';
import { FormService } from '../../../../services/form.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { TextAreaFieldComponent } from '../../../../components/form/textarea-field/textarea-field.component';


@Component({
  selector: 'proposals-details-form-request',
  imports: [NgbAlert, InputFieldComponent, TextAreaFieldComponent, ReactiveFormsModule],
  templateUrl: './proposals-details-form-request.component.html',
  styleUrl: './proposals-details-form-request.component.scss'
})
export class ProposalsDetailsFormRequestComponent {

  @Input() proposal?: any;
  @Input() readonlyProposalDetails: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  constructor(
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private proposalsService: ProposalsService
  ) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      summary: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      note: new FormControl(''),
      notesForClient: new FormControl('')
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['proposal'] && changes['proposal'].currentValue) {
      this.form.patchValue({
        summary: this.proposal.summary,
        description: this.proposal.description,
        note: this.proposal.note,
        notesForClient: this.proposal.notesForClient
      });
    }
  }

  /**
   * *******************
   * Submit form methods
   * *******************
   */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    
    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      this.submitFormSuccess(values);
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */



  getProposalSummaryInput(): FormControl { return this.getFormControl('summary');}
  getProposalDescriptionInput(): FormControl { return this.getFormControl('description');}
  getProposalNotesInput(): FormControl { return this.getFormControl('note'); }
  getProposalNotesForClientInput(): FormControl { return this.getFormControl('notesForClient'); }
  
  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
